import * as Yup from "yup";

const precioOpcional = Yup.string()
  .trim()
  .matches(/^\d+(\.\d{1,2})?$/, { message: "Solo números (ej. 135 o 39.50)", excludeEmptyString: true });

export const FormProductoScheme = () => {
  return Yup.object().shape({
    seccionId: Yup.string().required("Elige una sección"),
    nombre: Yup.string()
      .required("El campo es requerido")
      .trim()
      .max(80, "Máximo 80 caracteres"),
    descripcion: Yup.string().trim().max(300, "Máximo 300 caracteres"),
    precio: precioOpcional,
    disponible: Yup.boolean(),
  });
};
